import {
  SimpleShowLayout,
  Show,
  TextField,
  ReferenceField,
  Datagrid,
  ArrayField,
  NumberField,
  SimpleList,
  BooleanField,
  Labeled,
} from "react-admin";
import { Box, Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { administrationRequests } from "api/administrationApi";
import { SectionTitle } from "features/SectionTitle";

const ShowPreferences = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за преференция"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          spacing={2}
          container
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Заявява се при кандидатстване">
              <BooleanField source="isZvo" />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
      <SimpleShowLayout>
        <SectionTitle
          title="Отстъпки"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Box
          container
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            sx={12}
            md={4}
          >
            <ArrayField
              source="discounts"
              label=" "
            >
              {isMobile ? (
                <SimpleList />
              ) : (
                <Datagrid
                  rowClick={false}
                  bulkActionButtons={false}
                  sx={settings.style.secondaryDatagrid}
                >
                  <ReferenceField
                    source="taxTypeId"
                    label="Такса"
                    reference={administrationRequests.getTaxTypesSelect()}
                  >
                    <TextField
                      label="Такса"
                      source="name"
                    />
                  </ReferenceField>
                  <NumberField
                    label="Процент"
                    source="percentage"
                  />
                </Datagrid>
              )}
            </ArrayField>
          </Grid>
        </Box>
      </SimpleShowLayout>
      <SimpleShowLayout>
        <SectionTitle
          title="Декларации"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Box
          container
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <ArrayField
            source="documentTypes"
            label=" "
          >
            {isMobile ? (
              <SimpleList />
            ) : (
              <Datagrid
                rowClick={false}
                bulkActionButtons={false}
                sx={settings.style.secondaryDatagrid}
              >
                <ReferenceField
                  source="id"
                  label="Документ"
                  reference={administrationRequests.getPreferenceDocumentTypesSelect()}
                >
                  <TextField
                    label="Документ"
                    source="name"
                  />
                </ReferenceField>
                <NumberField
                  label="Брой"
                  source="count"
                />
              </Datagrid>
            )}
          </ArrayField>
        </Box>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowPreferences;
